import { useSearchParams } from 'react-router-dom';
import { useCallback, useMemo } from 'react';
import { SchoolYearValue, useResultsDataContext } from '../../ResultsDataContext';
import { FilterSearchParam } from '../../../../../../shared-components/elementis/types/FilterSearchParam';

export function useSelectedSchoolYear() {
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    schoolYears,
    loading: { schoolYears: schoolYearsLoading },
  } = useResultsDataContext();

  const selectedSchoolYearId = searchParams.get(FilterSearchParam.SchoolYear);

  const selectedSchoolYear = useMemo(() => {
    if (schoolYearsLoading) return null;

    if (selectedSchoolYearId) {
      return Object.values(schoolYears!).find(x => x.id === selectedSchoolYearId) || null;
    }

    return null;
  }, [selectedSchoolYearId, schoolYears, schoolYearsLoading]);

  const setSelectedSchoolYear = useCallback(
    (schoolYear: SchoolYearValue) => {
      setSearchParams(prev => {
        const newParams = new URLSearchParams(prev);
        newParams.set(FilterSearchParam.SchoolYear, schoolYear.id);
        newParams.delete(FilterSearchParam.School);
        newParams.delete(FilterSearchParam.Groups);
        newParams.delete(FilterSearchParam.Members);
        newParams.delete(FilterSearchParam.Exercises);

        return newParams;
      });
    },
    [setSearchParams],
  );

  return [selectedSchoolYear, setSelectedSchoolYear] as const;
}
